import { combineReducers } from 'redux';
import { NAME as billingKey, billingReducer } from './ducks/billing';
import { NAME as billItemsKey, billItemsReducer } from './ducks/billItems';
import { NAME as billNameKey, billNameReducer } from './ducks/billName';
import { NAME as billsKey, billsReducer } from './ducks/bills';
import { NAME as itemAssignmentKey, itemAssignmentReducer } from './ducks/itemAssignment';
import { NAME as changeBillOwnerKey, changeBillOwnerReducer } from './ducks/changeBillOwner';
import {
    NAME as changeBillAssociatedAccountKey,
    changeBillAssociatedAccountReducer,
} from './ducks/changeAssociatedAccount';
import { paymentReducer, NAME as paymentsKey } from './ducks/payments';

export * from './reinstate';

export { NAME as billingKey } from './module';

export const billingModuleReducer = combineReducers({
    [billingKey]: billingReducer,
    [billItemsKey]: billItemsReducer,
    [billsKey]: billsReducer,
    [itemAssignmentKey]: itemAssignmentReducer,
    [paymentsKey]: paymentReducer,
    [billNameKey]: billNameReducer,
    [changeBillOwnerKey]: changeBillOwnerReducer,
    [changeBillAssociatedAccountKey]: changeBillAssociatedAccountReducer,
});

export { default as ChangeBillingDetails } from './ChangeBillingDetails/ChangeBillingDetails';
export { prefetchRebateForm } from './rebate/initialize';
export { AccountBillingContainer } from './AccountBilling';
export { GroupBillingContainer } from './GroupBilling';
export { RebateBillContainer } from './rebate/initialize';
